<template>
	<div>
		<DiceControl @subcommand="subcommand"></DiceControl>
	</div>
</template>

<script>
import BaseSlide from './BaseSlide';
import DiceControl from '../controls/DiceControl';

export default {
	name: 'DiceExampleSlide',
	mixins: [BaseSlide],
	components: {
		DiceControl,
	},
};
</script>

<style></style>
